import { EyeIcon } from '@heroicons/react/24/solid'
import { Input, Select, Toggle } from "@/components/ui"
import { useMandatForm } from './MandatFormContext'
import { mandatTypes } from './mandatsSlice'
import Contact from "../biens/Contact"
import ProprietaireFields from '../biens/mandat/ProprietaireFields'

const typeMandatOptions = Object.entries(mandatTypes).map(
  ([key, value]) => ({
    label: value.charAt(0).toUpperCase() + value.slice(1), 
    value: key
  })
)

export default () => {
  // Récupérer les valeurs du contexte
  const { mandat, control, formErrors, hasError, getErrorMessage, getValues, watch } = useMandatForm()

  const typeMandat = watch("type_mandat")

  const handleDownload = (file) => {
    window.open(mandat[file].url, '_blank')
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
      <div className="flex flex-col items-start gap-4">  
        <div className="w-full">
          <label className="label">
            <span className="label-text font-semibold">Propriétaires signataires</span>
          </label>
          <div className="space-y-2">
            <ProprietaireFields
              control={control}
              formErrors={formErrors}
            />
          </div>
        </div>
        <Toggle.Form
          name="cle_dispo"
          control={control}
          label="Clé dispo à l'agence"
        />

        <Input.File control={control}
          name="remise_cles_file"
          label="Remise de clé"
          defaultValue={getValues("remise_cles_file")?.filename ? "Modifier le fichier" : ""}
          inputProps={{accept: ".pdf"}}
          canDelete={true}
        />
      </div>

      <div className="flex flex-col items-start gap-4">  
        <Select.Form 
          control={control} 
          name="type_mandat" 
          label="Type de mandat"
          options={typeMandatOptions}
          validator={{hasError, getErrorMessage}}
          disabled={!!mandat.type_mandat}
        />
        <div className="text-xs text-gray-600 -mt-2">
          Le type de mandat ne peut pas être modifié.
        </div>

        <Input.Text 
          name="numero"
          control={control}
          label="N° mandat"
          validator={{hasError, getErrorMessage}}
        />

        <Input.Date 
          name="date_signature"
          control={control}
          label="Date de signature"
          validator={{hasError, getErrorMessage}}
        />

        <div className="flex justify-between items-start">
          <Input.File control={control}
            name="mandat_file"
            label="Mandat"
            defaultValue={mandat.mandat_file ? "Modifier le fichier" : ""}
            inputProps={{accept: [".pdf"]}}
            className="max-w-[350px]"
            canDelete={true}
          />
          { mandat.mandat_file && (
            <button 
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                handleDownload("mandat_file")
              }}
              className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400 ml-2"
              title={`Voir le mandat`} aria-label={`Voir le mandat`}
            >
              <EyeIcon/>
            </button>
          )}
        </div>
      </div>

      { typeMandat === "vente" &&
          <div className="flex flex-col items-center gap-4">  
            <Toggle.Form
              name="exclusivite"
              control={control}
              label="Exclusivité"
            />
          </div>
      }
    </div>
  )
}